import ParameterFieldBase from '../../../../_common/platform/ts/ParameterFieldBase';

import EditComponent, { IChartBreaksFieldOptions } from './ChartBreaksField_inThemes';

export class ChartBreaksField_inThemes extends ParameterFieldBase<IChartBreaksFieldOptions> {
    public static EditComponent = EditComponent;
    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?: IChartBreaksFieldOptions) {
        if (defaultVal == null) {
            defaultVal = ChartBreaksField_inThemes.getDefaultValue();
        }

        super(glob, title, [], validators, defaultVal, options);
    }
}
